module.exports = __webpack_public_path__ + "static/media/2.87b10060.png";